import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import {useSolv} from "./SolvProvider"
import getLogger from "./Logging.js"
import Page403 from "../Page403";
import Page404 from "../Page404";
import {storeReferrer} from "./SigninupUtils";

const log = getLogger("PrivateRoute")

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { auth } = useSolv();

  return (
    <Route
      {...rest}
      render={props => {
        if (auth.isAuthenticated) {
          return <Component {...props} {...rest} />;
        }
        storeReferrer(props?.location)
        return (
          <Redirect
            to={{ pathname: `/signin`, state: { referrer: props?.location } }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;

export const RouteEx = ({component: Component, clientComponent: ClientComponent, adminComponent: AdminComponent, ...rest}) => {
  const {auth} = useSolv()
  return (
    <Route {...rest} render={props => {
      return (
        Component ? (
          <Component {...props} {...rest}/>
        ) : (
          auth.isAuthenticated ? (
            auth.session?.user?.isClient() ? (
              ClientComponent ? (
                <ClientComponent {...props} {...rest}/>
              ) : (
                <Page403 {...props} {...rest}/>
              )
            ) : (
              AdminComponent ? (
                <AdminComponent {...props} {...rest}/>
              ) : (
                <Page404 {...props} {...rest}/>
              )
            )
          ) : (
            <Redirect to={{pathname: `/signin`, state: {referrer: props?.location}}}/>
          )
        )
      )
    }}/>
  )
}

